export enum BookLayoutStatus {
  Default,
  GlobalSuccess1,
  GlobalSuccess23,
  MyLittleFun,
}
export enum AllowTranslateType {
  NotAllow,
  Allow,
}

export enum KindOfBook {
  Free, // Sách miễn phí
  FeeCharging, // Sách trả phí
}

export enum GameType {
  Game,
  Sachmem,
  PDF,
}

export enum SkillLevel {
  Easy,
  Medium,
  Difficult,
}
